import { render, staticRenderFns } from "./CourseFinished.vue?vue&type=template&id=16740dfb&"
import script from "./CourseFinished.vue?vue&type=script&lang=ts&"
export * from "./CourseFinished.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports